export default {
  // 模块名称
  taskCenter: {
    // 按钮类
    button: {
      save: 'Save',
      reset: 'Reset',
      conform: 'Confirm',
      cancel: 'Cancel',
      prompt: 'Prompt',
      whole: 'All',
      search: 'Query',
      close: 'Close',
      review: 'Review',
      assign: 'Assign',
      frame: 'Choose',
      export: 'Export'
    },
    // 文字标签类
    label: {
      count: 'Number',
      creator: 'Designator',
      doPerson: 'Executive',
      data: 'Date',
      taskStatus: 'Status',
      priority: 'Priority',
      taskType: 'Task type',
      modify: 'Modify',
      review: 'Review',
      delete: 'Delete',
      start: 'Start',
      close: 'Close',
      detail: 'Detail',
      noStart: 'Unstarted',//'Not initiated',
      wait: 'to be audited',//'Pending review',
      executing: 'in execution',
      add: 'Add',
      success: 'Success',
      dealWitn: 'The task has been processed',
      taslDetail: 'Task details',
      creators: 'Designator: ',
      taskTypes: 'Task type：',
      taskStatuss: 'Task status：',
      taskName: 'Task name：',
      taskNames: 'Task name',
      taskPriority: 'Priority：',
      taskVisibility: 'Visibility：',
      createTime: 'Assign time:',
      modifyTime: 'Finish time',
      areaDevGroupName: 'Area: ',
      desc: 'Description: ',
      comment: 'Review comments: ',
      operator: 'Executor: ',
      action: 'Execution action: ',
      descs: 'Dscription:',
      file: 'Documents: ',
      deviceName: 'Device Name: ',
      alarmLevel: 'Alarm level: ',
      alarmTypeText: 'Alarm type: ',
      alarmTime: 'Alarm time: ',
      urgent: 'urgent',
      resDetail: 'Resource details',
      doPersons: 'Executive',
      doDetail: 'Execution details',
      alarmDetail: 'Alarm details',
      executor: 'Number',
      executorName: 'Name',
      status: 'Situation',
      finishTime: 'Complete time',
      urgentFinish: 'Prompt success',
      taskTeview: 'Task review',
      doPersonsStaus: 'Execution status',
      score: 'Evaluation level',
      conmments: 'Review comments: ',
      olevel: 'First level',
      tlevel: 'Secondary',
      thrlevel: 'Third level',
      folevel: 'Four levels',
      flevel: 'Five levels',
      alarmDetailLevel: 'Alarm level',
      alarmDetailType: 'Alarm type',
      groupChoice: 'Select from group',
      mapChoice: 'Choose from the map',
      abovefile: 'Related documents',
      taskNamess: 'Task name：',
      taskVisibilitys: 'Visibility',
      requiredStartTimeProp: 'Start time',
      chooseArea: 'select area',
      mapChoices: 'Map selection',
      taskDesc: 'Task description',
      closeReson: 'Reason for close: ',
      to: 'to',
      no: 'No',
      taskStartTime: 'Start Time',
      taskCreateTime: 'Creation time',
      statuss: 'Status',
      closeTask: 'Close',
      noData: 'No data',
      exporting: 'Exporting'
    },
    // 提示类
    placeholder: {
      chooseDate: 'Select date',
      taskName: 'Please enter task name',
      choosePlease: 'please choose',
      enterContent: 'Please input Task description',
    },
    // 消息类
    message: {
      statusRe: 'The task status has been refreshed!',
      deleteWarn: 'Are you sure you want to delete it?',
      deleteOk: 'Delete the success',
      cancelDel: 'Cancelled delete',
      startTask: 'Are you sure you want to start task?',
      taskSucc: 'Task started successfully',
      reSuc: 'Review the success',
      timeMore: 'Start time cannot be greater than end time',
      disableNull: 'Review comments cannot be empty!',
      commentLen: 'The length of the review is between 0 and 100',
      choosePerson: 'Please select executive',
      taskNameWoed: 'The task name cannot contain special characters!',
      enterLen: 'Please enter 4-50 characters!',
      deviceInfoLen: 'Device name information is between 8 and 30',
      chooseName: 'Please enter device name',
      chooseAlarmLevel: 'Please select alarm level',
      chooseAlarm: 'Please select alarm type',
      chooseStart: 'Please select start time',
      choosePriority: 'Please select priority',
      chooseVisibilitys: 'Please select visibility',
      chooseTime: 'Please select time',
      chooseType: 'Please select task type',
      choosePersons: 'Please select security personnel',
      taskLength: 'The task description is between 0 and 500 in length',
      chooseArea: 'Please select area!',
      enterStart: 'Please enter the request start time',
      startEnd: 'The start time required is at least greater than the current time!',
      searchFail: 'Failed to query region information.',
      dealSuc: 'The task has been processed',
      taskEAnd: 'The alarm status is cleared,the task ends.',
      closeLen: 'The reason for the task shutdown is between 0-255.',
      closeReason: 'Please select the reason for the task!',
      uploadFail: 'upload failed',
      suffixErr: 'Image format is limited to JPG, JPEG, PNG, BMP, and the video format is limited to MP4.',
      sizeErr: 'Image size is limited to 2M',
      countErr: 'The number of pictures cannot exceed 10',
      countErrs: 'The number of videos cannot exceed 3',
      notSupport: 'Your browser does not support the video tag.',
      videoBiger: 'Video size is limited to',
      size: 'M',
      createDate: 'The Date is not entered, and the last 7 days of data is exported by default?',
      export30: 'Export date span cannot exceed 30 days',
      selectdate: 'Please select the full date'
    },
    // 标题类
    title: {
      allTasks: 'All tasks',
      noFinishTask: 'Unfinished task',
      finishTask: 'Completed task',
      assignTask: 'My assignment',
      onlyShow: 'Show only my assignments',
      assignTasks: 'Assign task',
      choose: 'select',
      taskRecords: 'Task records'
    }
  }
}
